export default __webpack_public_path__ + "static/product3-f583da61630bc55f2f258b62e42800fc.png";